import React, { useEffect, ReactNode, VFC } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import CircularProgress from '@mui/material/CircularProgress';

import { RootState } from '../../store/rootState';
import { selectAuth } from '../../store/modules/Auth/selectors';
import { HOME } from '../../constants/routing';

const ProgressWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
`;

interface Props {
  children: ReactNode;
}
const AuthRequired: VFC<Props> = ({ children }: Props) => {
  const { loading, loaded, authenticated } = useSelector((state: RootState) => {
    const authState = selectAuth(state);
    return {
      loading: authState.loading,
      loaded: authState.loaded,
      authenticated: authState.authenticated,
    };
  });

  useEffect(() => {
    // 認証APIの読み込みが終わって、認証状態ではない場合、トップページへ遷移する
    if (loaded && !authenticated) {
      // Client side renderingへの移行が完了したら、react-router-domのhistoryを使って実装する
      window.location.replace(HOME);
      return;
    }
  }, [loaded, authenticated]);

  if (loading || !loaded) {
    return (
      <ProgressWrapper>
        <CircularProgress />
      </ProgressWrapper>
    );
  }

  return <>{children}</>;
};

export default AuthRequired;
